import request from '@/utils/request';

//获取openid
export async function CourseOpenId(params: any): Promise<any> {
  return request(`/api/v1/wechat/openId`, {
    method: 'POST',
    data: {
      code: params,
    },
  });
}

//支付
export async function CoursePay(params: any): Promise<any> {
  const id = params.id;
  delete params.id;
  return request(`/api/v1/course/${id}/new/user/quick/pay`, {
    method: 'POST',
    data: params,
  });
}

//=================我的=======================

export async function MyApi(): Promise<any> {
  return request(`/api/v1/user/center`);
}
